import { React, useState } from 'react'
import { Typography, Grid, Box } from '@material-ui/core';
import useVendor from './../../hooks/useVendor';
import VendorCard, { VendorCardSkeleton } from './VendorCard';
import AddIcon from '@material-ui/icons/Add';
import { ButtonSuccess } from './../../shared/components/ButtonSucces';
import VendorFormModal from "./VendorFormModal";
import VendorCreationModal from "./VendorCreationModal";

const Vendors = ({ vendor }) => {
    const [modalState, setModalState] = useState(false);
    const handleCancel = () => {
        setModalState(false);
    }

    const handleOpen = () => {
        setModalState(true);
    }

    const { vendors, isLoading } = useVendor();

    // console.log(vendors)
    
    // const truncate = (str) => {
	// 	return str?.length > 10 ? str.substr(0, 7) + "..." : str;
	// };
    return (
        <div>

            {modalState && <VendorCreationModal show={modalState} onClose={handleCancel} />}

            <Grid container justify="space-between">
                <Grid item>
                    <Typography variant="h6" color="textSecondary" gutterBottom>
                        LISTE DES VENDORS
                    </Typography>
                </Grid>
                <Grid item >
                    <ButtonSuccess size="small"
                        variant="contained"
                        color="primary"
                        onClick={handleOpen}
                        startIcon={<AddIcon />}
                    >
                        Add Vendors
                    </ButtonSuccess>
                </Grid>
            </Grid>
            <Box style={{ height: 20 }} />
            <Grid container spacing={4} >
                
                {isLoading ?
                    <VendorCardSkeleton />
                    : vendors && vendors.map((vendor, idx) => (
                        <Grid key={idx} item xs={12} sm={6} md={4}>
                            <VendorCard
                            style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap',   minWidth:5 }}
                                vendor={vendor}
                            />
                        </Grid>
                    ))}
            </Grid>

            <VendorFormModal/>
        </div>
    )
}

export default Vendors